import { ENDPOINTS } from '@common/consts'
import axios from '@api'

export const fetchDataLayer = async () => {
  return axios.get(ENDPOINTS.DATA_LAYER)
}
